 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"87a01437998b949f34638dd3a8079e02d77c6eac","1":"1bfc9850","2":"2caee59394e083fc8786e4e909f2a3eb3caa15bf","3":"751d976b3eb85ad1af9213dc7fb5e3ded53dfecf","4":"styles","5":"component---src-pages-component-navbar-js","6":"5c5332cd85eb525e813332ffa4ba78bed9f27cf4","7":"dab1228368f939ef4e8b05d3b965bdfc492d1d8f","8":"143380c616827d3b70b86c357c39dd7816e2af25","9":"3f1aa5d83fbbc91e9c82845f953c77acd01095e0","10":"a44e2ad6b7ff9dc8bde4c9aa7c67891c267c28c8","11":"c67c7fe39eded3b7fa22218bf7b4c422c604265d","12":"cf45aa99e7712aa61a8f64890ebe53e2fd0783c5","13":"d03f99bccae07ac8e126fdc4a38a20be2b588051","16":"component---src-pages-2-density-js","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-bannerproperty-js","20":"component---src-pages-bestseller-js","21":"component---src-pages-component-about-us-js","22":"component---src-pages-component-banner-js","23":"component---src-pages-component-banner-property-js","24":"component---src-pages-component-best-seller-js","25":"component---src-pages-component-best-seller-page-js","26":"component---src-pages-component-carousel-slide-js","27":"component---src-pages-component-carousel-top-js","28":"component---src-pages-component-character-js","29":"component---src-pages-component-contact-js","30":"component---src-pages-component-details-js","31":"component---src-pages-component-footer-js","32":"component---src-pages-component-instagram-js","33":"component---src-pages-component-kids-page-js","34":"component---src-pages-component-men-page-js","35":"component---src-pages-component-modal-modal-index-js","36":"component---src-pages-component-navbar-top-js","37":"component---src-pages-component-new-product-js","38":"component---src-pages-component-preview-new-js","39":"component---src-pages-component-two-density-js","40":"component---src-pages-component-women-page-js","41":"component---src-pages-contact-js","42":"component---src-pages-details-js","43":"component---src-pages-index-js","44":"component---src-pages-kids-js","45":"component---src-pages-men-js","46":"component---src-pages-page-2-js","47":"component---src-pages-previewnew-js","48":"component---src-pages-view-17-adda-2-density-js","49":"component---src-pages-women-js"}[chunkId]||chunkId) + "-" + {"0":"357017c9039dbcf425a4","1":"cd2b75cc75b2d952014e","2":"c654019c5f60c4b606f7","3":"908924d2727079d4dd1c","4":"d92458a40376ac1079c2","5":"aaaca1e0bbd4a2f94af5","6":"dd937f5f636ec4a32b26","7":"b25950425b01005de2ce","8":"4adfecae4afc89bf494a","9":"df76e668487941c65923","10":"2b350393c2114c09d1d5","11":"4d439144caefdda282d3","12":"b941a7277e6c6ae44476","13":"4fd978638ef1f6195ca1","16":"ec254388dd28bec72e66","17":"9e74a9135e5a5abfd0da","18":"1196a0129f54aad05773","19":"138312ba5c13b67e9f89","20":"182a06c588be8988c5ed","21":"edb538201688a5ec863f","22":"f11d262a76ff0e6b9be5","23":"0ccb2e14f59d82407350","24":"404ccc2382e06ee5960a","25":"bd63d7981538546bdc52","26":"55bfc5baf44eafccde8f","27":"d593f2e49b1da50d7fe4","28":"a357986a4c9a8806d15b","29":"b835805e1438b1a7f279","30":"879b1a6ce3e539b0f8f0","31":"5582f3fffb77da413934","32":"6726e7a5e07d90605d2b","33":"2b9a620dc2afb277f453","34":"7693cfdf91a6194a48f9","35":"1e9f55a0835e381244d3","36":"74284e32c1a432773d5d","37":"6277263a96ced6fe6ae6","38":"d598fbce7c6c72bac617","39":"99c935051d69e29b4d27","40":"2906295b08ba106656df","41":"cb15afd1dc7bdaf8a68e","42":"223f5552750c0948b244","43":"257255a05817f46e4816","44":"874f431632999d19dc3c","45":"50e0c445c45bfaebb5dd","46":"0debfb56f12da158a1c3","47":"35a63fbbab8979976872","48":"47ffcb12d54faaaf6671","49":"b6b374f6ba25b9212f96"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"87a01437998b949f34638dd3a8079e02d77c6eac","1":"1bfc9850","2":"2caee59394e083fc8786e4e909f2a3eb3caa15bf","3":"751d976b3eb85ad1af9213dc7fb5e3ded53dfecf","4":"styles","5":"component---src-pages-component-navbar-js","6":"5c5332cd85eb525e813332ffa4ba78bed9f27cf4","7":"dab1228368f939ef4e8b05d3b965bdfc492d1d8f","8":"143380c616827d3b70b86c357c39dd7816e2af25","9":"3f1aa5d83fbbc91e9c82845f953c77acd01095e0","10":"a44e2ad6b7ff9dc8bde4c9aa7c67891c267c28c8","11":"c67c7fe39eded3b7fa22218bf7b4c422c604265d","12":"cf45aa99e7712aa61a8f64890ebe53e2fd0783c5","13":"d03f99bccae07ac8e126fdc4a38a20be2b588051","16":"component---src-pages-2-density-js","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-bannerproperty-js","20":"component---src-pages-bestseller-js","21":"component---src-pages-component-about-us-js","22":"component---src-pages-component-banner-js","23":"component---src-pages-component-banner-property-js","24":"component---src-pages-component-best-seller-js","25":"component---src-pages-component-best-seller-page-js","26":"component---src-pages-component-carousel-slide-js","27":"component---src-pages-component-carousel-top-js","28":"component---src-pages-component-character-js","29":"component---src-pages-component-contact-js","30":"component---src-pages-component-details-js","31":"component---src-pages-component-footer-js","32":"component---src-pages-component-instagram-js","33":"component---src-pages-component-kids-page-js","34":"component---src-pages-component-men-page-js","35":"component---src-pages-component-modal-modal-index-js","36":"component---src-pages-component-navbar-top-js","37":"component---src-pages-component-new-product-js","38":"component---src-pages-component-preview-new-js","39":"component---src-pages-component-two-density-js","40":"component---src-pages-component-women-page-js","41":"component---src-pages-contact-js","42":"component---src-pages-details-js","43":"component---src-pages-index-js","44":"component---src-pages-kids-js","45":"component---src-pages-men-js","46":"component---src-pages-page-2-js","47":"component---src-pages-previewnew-js","48":"component---src-pages-view-17-adda-2-density-js","49":"component---src-pages-women-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"aa532a9cd290d86e8541","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
